import { toast } from "react-toastify";
//@ts-ignore
import { getApiRoot } from "@careinfo/axios-service";
import { accessToken } from "../helpers/sessionKey";

const useDownload = (props: any) => {
  const download = async (
    downloadPath: string,
    filename,
    selectedItems = ""
  ) => {
    const BASE_URL = await getApiRoot();
    // Start the toast with the initial message and progress
    const toastId = toast("Starting download...", {
      type: "info",
      autoClose: false, // Disable auto-close
      draggable: false,
      progress: 0,
    });

    try {
      // Step 1: Start the report generation
      const response = await fetch(`${BASE_URL}${downloadPath}`, {
        method: "POST",
        headers: {
          Authorization: `JWT ${accessToken()}`,

          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ids: selectedItems?.split(",") }),
      });
      if (!response.ok) {
        throw new Error("Failed to start the report generation");
      }
      toast.update(toastId, {
        render: "Task started successfully...",
        progress: 0.33,
      });

      const data = await response.json();
      const pollAsyncUrl = `${BASE_URL}/download/api/download-history/check-for-download/?task_id=${data.task_id}`;
      // Step 2: Poll for the report generation status
      const pollResults = async () => {
        try {
          const asyncResponse = await fetch(pollAsyncUrl, {
            method: "GET",
            headers: {
              Authorization: `JWT ${accessToken()}`,
              "Content-Type": "application/octet-stream",
            },
          });
          if (asyncResponse.status !== 202) {
            const asyncData = await asyncResponse.blob();
            // Update the toast to indicate report generation completion
            toast.update(toastId, {
              render: "Report generation completed...",
              progress: 0.66,
            });

            // Step 3: Create a download link and trigger download
            const a = document.createElement("a");
            const fileURL = window.URL.createObjectURL(asyncData);
            document.body.appendChild(a);
            //@ts-ignore
            a.style = "display: none";
            a.href = fileURL;
            a.download = filename;
            a.click();

            // Final update to indicate download completion
            toast.update(toastId, {
              render: "Download complete!",
              type: "success",
              progress: 1,
            });
          } else {
            // Continue polling
            setTimeout(pollResults, 500);
          }
        } catch (error) {
          toast.update(toastId, {
            render: "An error occurred while downloading",
            type: "error",
            progress: 0,
          });
        }
      };

      // Start polling
      pollResults();
    } catch (error) {
      toast.update(toastId, {
        render: "An error occurred while downloading.",
        type: "error",
        progress: 0,
      });
    }
  };

  return { download };
};

export default useDownload;
